import React from 'react';
import { Navigate } from 'react-router-dom';
import useFeatureGate from '../hooks/useFeatureGate';
import useTierGrid from '../hooks/useTierGrid';
import TierComparisonGrid from '../components/TierComparisonGrid';
import PublicHeader from '../components/PublicHeader';
import SiteFooter from '../components/SiteFooter';
import { useAuth } from '../context/AuthContext';

export default function Pricing() {
  const { tiers, loading, error } = useTierGrid();
  const { user, loading: authLoading } = useAuth();
  const stripeEnabled = useFeatureGate('stripe_payments');

  // Only block access to pricing when stripe payments are explicitly disabled
  if (stripeEnabled === false) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-dark-900 flex flex-col">
      <PublicHeader />
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl font-bold text-white mb-2">Pricing</h1>
            <p className="text-sm text-gray-400 mb-6">Simple and transparent pricing.</p>

            {error && (
              <div className="mb-4 p-3 bg-red-900/20 border border-red-500/30 rounded-sm text-red-400">Unable to load tiers.</div>
            )}

            <TierComparisonGrid tiers={tiers} loading={loading} user={authLoading ? undefined : user} />
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
